import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION17: PdfComponent = {
  type: 'section',
  id: 's17',
  title: '17. Intellectual Property Rights',
  content: [
    {
      type: 'bulletList',
      id: 's17bullets',
      bulletType: 'number',
      content: [
        {
          copy: 'Nothing in this Agreement shall operate to assign or otherwise transfer any Intellectual Property Rights of either party to the other.',
        },
        {
          copy: "Each party acknowledges the other party's proprietary interest in and to its Intellectual Property Rights and will not use the other party's Intellectual Property in connection with this Agreement or otherwise without the prior written consent of the other party.",
        },
        {
          copy: "No party shall, other than as set out in this Agreement, acquire any rights in another party's Intellectual Property Rights.",
        },
        {
          copy: 'No party shall knowingly use any brand or mark similar to, or capable of being confused with, any Intellectual Property of the other party.',
        },
      ],
      prefix: '17',
    },
  ],
};
